export default class LocalStorage {
  public static get(key: string) {
    const item = localStorage.getItem(key) ?? '';
    return item.length > 0 ? JSON.parse(item) : null;
  }

  public static set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
    return LocalStorage;
  }
}
